import { HttpClient } from "app/library/client";
import { IListFilter, ResponseBase, ResponseContentBase, ResponseListBase } from "app/shared";
import { convertToQueryString } from "app/shared/functions";
import { api } from "app/utils/api";
import { getEndpoint } from "app/utils/service";
import { SpecificationTypeEntity } from ".";
import { SpecificationEntity } from "./types";

export default class SpecificationService {

    /** It gets all specifications. */
    async getSpecifications(options: IListFilter): Promise<ResponseBase<ResponseListBase<SpecificationEntity[]>>> {
        return HttpClient.getClient().get(getEndpoint(api.prefixes.specification.list + `?${convertToQueryString(options)}`));
    }

    /** It get specification by id */
    async getSpecification(specificationId: string): Promise<ResponseBase<ResponseContentBase<SpecificationEntity>>> {
        return HttpClient.getClient().get(getEndpoint(api.prefixes.specification.main) + specificationId);
    }

    /** It creates specification by request */
    async createSpecification(request: SpecificationEntity): Promise<ResponseBase<ResponseContentBase<SpecificationEntity>>> {
        return HttpClient.getClient().post(getEndpoint(api.prefixes.specification.main), request);
    }

    /** It updates specification by id */
    async updateSpecification(request: SpecificationEntity): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().patch(getEndpoint(api.prefixes.specification.main) + request.id, request);
    }

    /** It deletes specification by id */
    async deleteSpecification(specificationId: string): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().delete(getEndpoint(api.prefixes.specification.main) + specificationId);
    }

    /** It get all specification types */
    async getSpecificationTypes(options: IListFilter): Promise<ResponseBase<ResponseListBase<SpecificationTypeEntity[]>>> {
        return HttpClient.getClient().get(getEndpoint(api.prefixes.specificationType.list) + `?${convertToQueryString(options)}`);
    }

    /** It get spesific specification type by specification type id */
    async getSpecificationType(specificationTypeId: string): Promise<ResponseBase<ResponseContentBase<SpecificationTypeEntity>>> {
        return HttpClient.getClient().get(getEndpoint(api.prefixes.specificationType.main) + specificationTypeId);
    }

    /** It creates specification type by request */
    async createSpecificationType(request: SpecificationTypeEntity): Promise<ResponseBase<ResponseContentBase<SpecificationTypeEntity>>> {
        return HttpClient.getClient().post(getEndpoint(api.prefixes.specificationType.main), request);
    }

    /** It updates spesific specification type by id */
    async updateSpecificationType(request: SpecificationTypeEntity): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().patch(getEndpoint(api.prefixes.specificationType.main) + request.id, request);
    }

    /** It deletes spesific specification type by id */
    async deleteSpecificationType(specificationTypeId: string): Promise<ResponseBase<boolean>> {
        return HttpClient.getClient().delete(getEndpoint(api.prefixes.specificationType.main) + specificationTypeId);
    }
}
